import Moment from 'moment'
import Recur from 'simple-recur'

export default {
  data: function () {
    return {}
  },

  methods: {
    getRecurringTypes (showNone = true, isInstallment = false) {
      let recurringTypes = [
        {value: 'none', text: 'None'},
        {value: 'daily', text: 'Every day'},
        {value: 'weekly', text: 'Every week'},
        {value: 'biweekly', text: 'Every 2 weeks'},
        {value: 'triweekly', text: 'Every 3 weeks'},
        {value: 'monthly', text: 'Every month'},
        {value: 'bimonthly', text: 'Every 2 months'},
        {value: 'quarterly', text: 'Every 3 months'},
        {value: 'semiannually', text: 'Every 6 months'},
        {value: 'annually', text: 'Every 12 months'}
      ]

      if (isInstallment) {
        recurringTypes.splice(4, 1)
        recurringTypes.splice(5, 8)
      }

      if (!showNone) {
        recurringTypes.splice(0, 1)
      }

      return recurringTypes
    },

    // what field is changing
    // data for other fields to up
    //   push back to parent, bus?
    //   return array of changes to process by parent
    handleRecurringFieldChange (field, data) {
      console.log('handleRecurringFieldChange:', field)
      let changes = {}
      let paymentCount = this.calculatePaymentCountWithEndDate(data.frequency, data.start_date, data.end_date)

      if (data.is_installment) {
        paymentCount = this.calculatePaymentCountWithRecurringAmount(data.frequency, data.start_date, data.remaining_balance, data.amount)
      }

      // changes.payment_count = Math.ceil(paymentCount)

      if (field === 'balance' || field === 'frequency') {
        // keep balance / frequncy
        // calculate payments
        // keep amount
        // keep start_date
        // calculate end_date
        // calculate last_payment

        // calculate payments
        // let paymentCount = this.calculatePaymentCountWithRecurringAmount()
        // this.$set(data, 'payments', Math.ceil(paymentCount))
        // changes.payments = Math.ceil(paymentCount)

        // calculate end_date
        // this.$set(data, 'end_date', this.calculateEndDate())
        changes.end_date = this.calculateEndDate(data.frequency, data.start_date, paymentCount)

        if (data.is_installment) {
          // add last payment if remainder
          if (Math.ceil(paymentCount) > paymentCount) {
            // this.$set(data, 'last_amount', Number(data.remaining_balance - (Math.floor(paymentCount) * data.amount)).toFixed(2))
            changes.last_amount = Number(data.remaining_balance - (Math.floor(paymentCount) * data.amount)).toFixed(2)
          } else {
            // this.$set(data, 'last_amount', null)
            changes.last_amount = null
          }
        }
      } else if (field === 'payments') {
        // keep balance / frequncy
        // keep payments
        // calculate amount
        // keep start_date
        // calculate end_date
        // calculate last_payment

        paymentCount = data.payment_count

        if (data.is_installment) {
          // calculate installment payment amount
          let subtotal = data.remaining_balance / data.payment_count
          console.log(subtotal)

          if (isNaN(subtotal) || subtotal === 0 || subtotal === Infinity) {
            console.log('bomb out early')
            return {}
          } else {
            // this.$set(data, 'amount', Number(subtotal).toFixed(2))
            changes.amount = Number(subtotal).toFixed(2)
          }

          // add last payment if remainder
          let potentialAmount = data.payment_count * data.amount
          if (potentialAmount > data.remaining_balance) {
            // this.$set(data, 'last_amount', Number(data.remaining_balance - ((data.payments - 1) * data.amount)).toFixed(2))
            changes.last_amount = Number(data.remaining_balance - ((data.payment_count - 1) * data.amount)).toFixed(2)
          } else {
            // this.$set(data, 'last_amount', null)
            changes.last_amount = null
          }
        }

        // calculate end date
        // this.$set(data, 'end_date', this.calculateEndDate())
        changes.end_date = this.calculateEndDate(data.frequency, data.start_date, data.payment_count)
      } else if (field === 'amount') {
        // keep balance / frequncy
        // keep payments
        // calculate amount
        // keep start_date
        // calculate end_date
        // calculate last_payment

        // calculate # of payments
        if (data.ongoing) {
          // data.end_date = ''
          // data.payments = 0
          changes.end_date = ''
          changes.payment_count = 0
        } else {
          let paymentCount = this.calculatePaymentCountWithRecurringAmount()
          // data.payments = Math.ceil(paymentCount)
          // this.$set(data, 'payments', Math.ceil(paymentCount))
          changes.payment_count = Math.ceil(paymentCount)

          // add last payment if remainder
          if (Math.ceil(paymentCount) > paymentCount) {
            // data.last_amount = this.recurringRemainingBalance - (Math.floor(paymentCount) * data.amount)
            // this.$set(data, 'last_amount', Number(data.remaining_balance - (Math.floor(paymentCount) * data.amount)).toFixed(2))
            changes.last_amount = Number(data.remaining_balance - (Math.floor(paymentCount) * data.amount)).toFixed(2)
          } else {
            // this.$set(data, 'last_amount', null)
            changes.last_amount = null
          }
        }

        // calculate end date
        // data.end_date = this.calculateEndDate()
        // this.$set(data, 'end_date', this.calculateEndDate())
        changes.end_date = this.calculateEndDate(data.frequency, data.start_date, changes.payment_count)
      } else if (field === 'start_date') {
        // calculate End Date
        // calculate # or payments
        // calculate installment payments
        // if remainder, last payment

        // calculate end date
        // this.$set(data, 'end_date', this.calculateEndDate())
        changes.end_date = this.calculateEndDate(data.frequency, data.start_date, data.payment_count)
      } else if (field === 'end_date') {
        // calculate # of payments
        // calculate installment payments
        // no remainder, hide last payment

        changes.payment_count = this.calculatePaymentCountWithEndDate(data.frequency, data.start_date, data.end_date)
      }

      return changes
    },

    calculatePaymentCountWithRecurringAmount (frequency, startDate, remainingBalance, amount) {
      if (frequency === '' || frequency === 'none') {
        return 0
      }
      if (startDate === '') {
        return 0
      }
      if (remainingBalance === '') {
        return 0
      }
      if (amount === '') {
        return 0
      }

      return (remainingBalance / amount).toFixed(0)
    },

    calculateEndDate (frequency, startDate, paymentCount) {
      console.log('calculateEndDate', frequency, startDate, paymentCount)
      let endDate = ''

      if (frequency === 'none') {
        return endDate
      }
      if (startDate === '') {
        return endDate
      }
      if (paymentCount === '' || paymentCount < 1) {
        return endDate
      }
      if (paymentCount === 1) {
        return startDate
      }

      let count = paymentCount - 1

      if (frequency === 'daily') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count, 'days').format('YYYY-MM-DD')
      } else if (frequency === 'weekly') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'biweekly') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count * 2, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'triweekly') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count * 3, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'monthly') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'bimonthly') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count * 2, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'quarterly') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count * 3, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'semiannually') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count * 6, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'annually') {
        endDate = Moment(startDate, 'YYYY-MM-DD').add(count, 'years').format('YYYY-MM-DD')
      }

      return endDate
    },

    calculatePaymentCountWithEndDate (frequency, startDate, endDate) {
      let paymentCount = 0

      if (!frequency || frequency === 'none') {
        return paymentCount
      }
      if (!startDate) {
        return paymentCount
      }
      if (!endDate) {
        return paymentCount
      }

      let start = Moment(startDate)
      let end = Moment(endDate)

      if (frequency === 'daily') {
        paymentCount = end.diff(start, 'days') + 1
      } else if (frequency === 'weekly') {
        paymentCount = end.diff(start, 'weeks') + 1
      } else if (frequency === 'biweekly') {
        paymentCount = end.diff(start, 'weeks') / 2 + 1
      } else if (frequency === 'triweekly') {
        paymentCount = end.diff(start, 'weeks') / 3 + 1
      } else if (frequency === 'monthly') {
        paymentCount = end.diff(start, 'months') + 1
      } else if (frequency === 'bimonthly') {
        paymentCount = end.diff(start, 'months') / 2 + 1
      } else if (frequency === 'quarterly') {
        paymentCount = end.diff(start, 'months') / 3 + 1
      } else if (frequency === 'semiannually') {
        paymentCount = end.diff(start, 'months') / 6 + 1
      } else if (frequency === 'annually') {
        paymentCount = end.diff(start, 'years') + 1
      }

      return paymentCount
    },

    calculateNextRecurringDate (frequency, date) {
      let nextDate = ''

      if (frequency === 'daily') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      } else if (frequency === 'weekly') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(1, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'biweekly') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(2, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'triweekly') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(3, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'monthly') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(1, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'bimonthly') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(2, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'quarterly') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(3, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'semiannually') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(6, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'annually') {
        nextDate = Moment(date, 'YYYY-MM-DD').add(1, 'years').format('YYYY-MM-DD')
      }

      return nextDate
    },

    calculatePreviousRecurringDate (frequency, date) {
      let previousDate = ''

      if (frequency === 'daily') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
      } else if (frequency === 'weekly') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(1, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'biweekly') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(2, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'triweekly') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(3, 'weeks').format('YYYY-MM-DD')
      } else if (frequency === 'monthly') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(1, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'bimonthly') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(2, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'quarterly') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(3, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'semiannually') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(6, 'months').format('YYYY-MM-DD')
      } else if (frequency === 'annually') {
        previousDate = Moment(date, 'YYYY-MM-DD').subtract(1, 'years').format('YYYY-MM-DD')
      }

      return previousDate
    },

    allowedEndDates (frequency, date, start) {
      let startDate = Moment(start)
      let testDate = Moment(date)

      if (frequency === 'daily') {
        return testDate.diff(startDate, 'days') % 1 === 0
      } else if (frequency === 'weekly') {
        return testDate.diff(startDate, 'days') % 7 === 0
      } else if (frequency === 'biweekly') {
        return testDate.diff(startDate, 'days') % 14 === 0
      } else if (frequency === 'triweekly') {
        return testDate.diff(startDate, 'days') % 21 === 0
      } else if (frequency === 'monthly') {
        let recurrence = new Recur({units: 1, measure: 'months', start: startDate})
        return recurrence.matches(date)
      } else if (frequency === 'bimonthly') {
        let recurrence = new Recur({units: 2, measure: 'months', start: startDate})
        return recurrence.matches(date)
      } else if (frequency === 'quarterly') {
        let recurrence = new Recur({units: 3, measure: 'months', start: startDate})
        return recurrence.matches(date)
      } else if (frequency === 'semiannually') {
        let recurrence = new Recur({units: 6, measure: 'months', start: startDate})
        return recurrence.matches(date)
      } else if (frequency === 'annually') {
        let recurrence = new Recur({units: 1, measure: 'years', start: startDate})
        return recurrence.matches(date)
      }
      return false
    },

    getScheduledPayments (schedule) {
      let frequency = schedule.recurring_type
      let start = schedule.start
      let end = (schedule.end ? schedule.end : '2099-12-31')

      if (frequency === 'none' || !start || !end) {
        return []
      }
      return this.getAllInstallments(frequency, start, end)
    },

    // @TODO Should this be outside of the central component since it depends on the transaction processor?
    getInstallments (transaction) {
      let frequency = transaction.modify_recurring_type ? transaction.modify_recurring_type : transaction.recurring_type
      let start = transaction.modify_recurring_start ? transaction.modify_recurring_start : transaction.recurring_start
      let end = transaction.modify_recurring_end ? transaction.modify_recurring_end : (transaction.recurring_end ? transaction.recurring_end : '2099-12-31')

      // @TODO should we be taking into account settled parents, current dates, and FAPS logic here?

      // initial transaction is recorded as parent, skip if settled
      // if (transaction.settled) {
      //   start = Moment(start, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      // }
      // if (transaction.settled) {
      // start = this.calculateNextRecurringDate(frequency, start)
      // }

      // @TODO FAPS doesn't count the last date
      // end = Moment(end, 'YYYY-MM-DD').subtract(1, 'days').format('YYYY-MM-DD')
      // let potentialEnd = this.calculatePreviousRecurringDate(frequency, end)
      // if (Moment(potentialEnd).isAfter(start)) {
      //   end = potentialEnd
      // }

      if (frequency === 'none' || !start || !end) {
        return []
      }

      // let today = new Date()
      // let startDate = new Date(start)
      // if (startDate > today) {
      //   return this.getAllInstallments(frequency, start, end)
      // } else {
      //   // return this.getAllInstallments(frequency, today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(), end)
      //   return this.getAllInstallments(frequency, today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate(), end)
      // }
      return this.getAllInstallments(frequency, start, end)
    },

    getAllInstallments (frequency, startDate, endDate) {
      // @TODO why does this have to happen to get the extra day? GMT?
      startDate = Moment(startDate, 'YYYY-MM-DD').format('YYYY-MM-DD')
      endDate = Moment(endDate, 'YYYY-MM-DD').format('YYYY-MM-DD')

      let installments = []

      if (frequency === 'daily') {
        let recurrence = new Recur({units: 1, measure: 'days', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'weekly') {
        let recurrence = new Recur({units: 7, measure: 'days', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'biweekly') {
        let recurrence = new Recur({units: 14, measure: 'days', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'triweekly') {
        let recurrence = new Recur({units: 21, measure: 'days', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'monthly') {
        let recurrence = new Recur({units: 1, measure: 'months', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'bimonthly') {
        let recurrence = new Recur({units: 2, measure: 'months', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'quarterly') {
        let recurrence = new Recur({units: 3, measure: 'months', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'semiannually') {
        let recurrence = new Recur({units: 6, measure: 'months', start: startDate, end: endDate})
        installments = recurrence.next(100)
      } else if (frequency === 'annually') {
        let recurrence = new Recur({units: 1, measure: 'years', start: startDate, end: endDate})
        installments = recurrence.next(100)
      }

      // return, removing extra null entries from simple-recur as there is no way to ask for 'all'
      return installments.filter(x => x)
    },

    totalAmountSettled (transaction) {
      let totalSettled = 0

      if (transaction.response_code === '000' && transaction.settled) {
        totalSettled += transaction.total_amount
      }

      if (!transaction.hasOwnProperty('associatedTransactions') || transaction.associatedTransactions.length < 1) {
        return totalSettled
      }

      let childrenTotalSettled = transaction.associatedTransactions.reduce((runningTotal, childTransaction) => {
        if ((childTransaction.request_type === 'sale' || childTransaction.request_type === 'ach') && childTransaction.response_code === '000' && childTransaction.settled && childTransaction.parent_transaction_id === transaction.id) {
          return runningTotal + childTransaction.total_amount
        }
        return runningTotal
      }, 0)

      return totalSettled + childrenTotalSettled
    }

  }
}



// WEBPACK FOOTER //
// ./src/mixins/recurring.js